import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import KeysAddressSection from '@/orderDetails/KeysAddressSection';
import PropertyAccessIcon from '@/svg-icons/PropertyAccess';

const PropertyAccessSection = ({ data }) => (
  <div className="w-full">
    <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
      <PropertyAccessIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
      <FormattedMessage id="propertyAccess" />
    </div>

    <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
      {!!data.type && (
        <div className="w-full mb-[1vw]" data-cy="order-details-access-info-type">
          <div className="font-bold">
            <FormattedMessage id="keysLocationRadio" />
          </div>
          <span className="block mb-[0.5vw]">{data.type}</span>

          {(data.type === 'Outro' || data.type === 'Na imobiliária') && !!data.address && (
            <KeysAddressSection address={data.address} />
          )}
        </div>
      )}

      {!!data.keysDevolutionType && (
        <div className="w-full mb-[1vw]" data-cy="order-details-access-info-type">
          <div className="font-bold">
            <FormattedMessage id="keysDevolutionType" />
          </div>
          <span className="block mb-[0.5vw]">
            <FormattedMessage id={data.keysDevolutionType} />
          </span>

          {(data.keysDevolutionType === 'Outro' || data.keysDevolutionType === 'Na imobiliária') && !!data.keysDevolutionAddress && (
            <KeysAddressSection address={data.keysDevolutionAddress} />
          )}
        </div>
      )}

      {!!data.keysLocation && (
        <div className="w-full mb-[1vw]" data-cy="order-details-keys-location">
          <div className="font-bold">
            <FormattedMessage id="keysLocation" />
          </div>
          <span>{data.keysLocation}</span>
        </div>
      )}

      {data.accessDetails && (
        <div className="w-full mb-[1vw]" data-cy="order-details-property-access-details">
          <div className="font-bold">
            <FormattedMessage id="accessDetails" />
          </div>
          <div className="whitespace-pre-wrap">
            {data.accessDetails}
          </div>
        </div>
      )}
    </div>
  </div>
);

PropertyAccessSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PropertyAccessSection;
